import pl from "@locales/patient/program_sharing/pl.json";
import en from "@locales/patient/program_sharing/en.json";

export default {
  pl: pl,
  en: en,
};
